<dynamic-form
  *ngIf="isOkForLoad"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [erroremessage]="erroremessage"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <div class="content row">
    <div class="commentbtn col-4" *ngIf="isOkForLoad && comments && comments.length > 0">
      <div class="row">
        <ssg-button
          class="col-4"
          label="{{ item.Name }}"
          *ngFor="let item of comments"
          (click)="addItem(item.Name, dinput, cinput)"
          buttontype="button"
          size="medium">
        </ssg-button>
      </div>
    </div>
    <div class="col-8">
      <textarea
        [cols]="cols"
        [formControl]="formGroup.get('DebitCommentFormat')"
        [rows]="rows"
        [required]="true"
        (focus)="onChange('Debit')"
        #dinput
        placeholder="شرح بدهکار">
      </textarea>
      <textarea
        [cols]="cols"
        [formControl]="formGroup.get('CreditCommentFormat')"
        [rows]="rows"
        [required]="true"
        (focus)="onChange('Credit')"
        #cinput
        placeholder="شرح بستکار">
      </textarea>
    </div>
  </div>
  <ng-container class="footer">
    <ssg-button
      icon="fa fa-filter"
      buttontype="button"
      (click)="delete()"
      class="login-btn"
      label="حذف"
      size="medium"
      [disabled]="isNewRow"
      appearance="flat">
    </ssg-button>
  </ng-container>
</dynamic-form>
